<mat-sidenav-container class="app-container">
  <mat-sidenav mode="side" [opened]="!bp.isPhone()" disableClose="true" [ngClass]="'sidenav'">
    <div class="sidenav-container">
      <a routerLink="/callback" routerLinkActive="active" [attr.aria-label]="'SIDE_MENU.TOOLTIP.HOME' | translate">
        <img
          src="/assets/images/logo.svg"
          class="polytech-logo"
          alt=""
          matTooltip="{{ 'SIDE_MENU.TOOLTIP.HOME' | translate }}"
          [matTooltipPosition]="'right'"
        />
      </a>

      <div class="icons-container">
        <div class="upper-icons-container">
          @if (canAccessComponent$ | async) {
          <a
            routerLink="/components"
            routerLinkActive="active"
            id="link-components"
            class="icon-route"
            [attr.aria-label]="'SIDE_MENU.NAV.COMPONENTS' | translate"
            matTooltip="{{ 'SIDE_MENU.TOOLTIP.COMPONENTS' | translate }}"
            [matTooltipPosition]="'right'"
          >
            <svg-icon
              src="/assets/images/icon-48-components.svg"
              [svgStyle]="{ 'width.px': 35 }"
              [class]="'icon'"
            ></svg-icon>
          </a>
          } @if (canAccessProject$ | async) {
          <a
            routerLink="/projects"
            routerLinkActive="active"
            class="icon-route"
            [attr.aria-label]="'SIDE_MENU.NAV.PROJECTS' | translate"
            matTooltip="{{ 'SIDE_MENU.TOOLTIP.PROJECTS' | translate }}"
            [matTooltipPosition]="'right'"
          >
            <svg-icon
              src="/assets/images/icon-48-projects.svg"
              [svgStyle]="{ 'width.px': 35 }"
              [class]="'icon'"
            ></svg-icon>
          </a>
          } @if (canAccessGeofence$ | async) {
          <a
            routerLink="/geofences"
            routerLinkActive="active"
            class="icon-route"
            [attr.aria-label]="'SIDE_MENU.NAV.GEOFENCES' | translate"
            matTooltip="{{ 'SIDE_MENU.NAV.GEOFENCES' | translate }}"
            [matTooltipPosition]="'right'"
          >
            <svg-icon
              src="assets/icons/sidemenu_geofence.svg"
              [svgStyle]="{ 'width.px': 35 }"
              [class]="'icon'"
            ></svg-icon>
          </a>
          } @if (canAccessSetting$ | async) {
          <a
            routerLink="/admin/devices"
            routerLinkActive="active"
            class="icon-route"
            [attr.aria-label]="'SIDE_MENU.NAV.DEVICES' | translate"
            matTooltip="{{ 'SIDE_MENU.NAV.DEVICES' | translate }}"
            [matTooltipPosition]="'right'"
          >
            <svg-icon
              src="/assets/images/icon-48-sensor.svg"
              [svgStyle]="{ 'width.px': 35 }"
              [class]="'icon'"
            ></svg-icon>
          </a>
          }
        </div>

        <div class="lower-icons-container">
          <button
            type="button"
            id="link-out"
            class="icon-route"
            [attr.aria-label]="'SIDE_MENU.NAV.LOG_OUT' | translate"
            matTooltip="{{ 'SIDE_MENU.TOOLTIP.LOG_OUT' | translate }}"
            [matTooltipPosition]="'right'"
            (click)="logout()"
          >
            <svg-icon
              src="/assets/images/icon-48-log-out.svg"
              [svgStyle]="{ 'width.px': 35 }"
              [class]="'icon'"
            ></svg-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: #ffffff">
    <div class="full-height">
      <ng-content></ng-content>
    </div>
    @if (bp.isPhone()) {
    <app-bottom-nav
      [items]="(navItems$ | async) ?? []"
      [canAccessGeofence]="(canAccessGeofence$ | async) ?? false"
      (logout)="logout()"
    ></app-bottom-nav>
    }
  </mat-sidenav-content>
</mat-sidenav-container>
